import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../../enums/contentStack.js";
import { getConfigurationSettingByDeveloperKey } from "../../../../services/content/business.lib.js";
import { getMembershipTypesConfiguration, getConfigurationSettingByConfigKey } from "../../../../services/content/config.lib.js";
const withContentstack = (Component) => {
  const WrappedComponent = async (props) => {
    const { locale } = props;
    const membershipTypes = await getMembershipTypesConfiguration();
    const moduleSettings = await getConfigurationSettingByDeveloperKey(
      ContentType.ModuleSettings,
      "accountDrawer",
      locale
    );
    const accountMenuConfig = await getConfigurationSettingByConfigKey(
      ContentType.ConfigurationSetting,
      "account_menu_options"
    );
    if (!membershipTypes || !moduleSettings || !accountMenuConfig.custom) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      Component,
      {
        accountMenuOptions: accountMenuConfig.custom,
        ...props,
        membershipTypes,
        moduleSettings
      }
    );
  };
  return WrappedComponent;
};
export {
  withContentstack
};
